<div class="help-dialog">
  <div class="help-dialog-header d-flex align-items-center justify-content-between">
    <div class="help-title">How to use PPK Studio</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="help-dialog-body">
    <div class="mb-3">
      <div class="section-title">Workflow</div>
      <ol class="mb-2">
        <li>Upload <strong>Rover</strong> data and <strong>Base</strong> data.</li>
        <li>The system converts raw files to RINEX (<code>.obs</code> / <code>.nav</code>) in the backend.</li>
        <li>When required RINEX files are ready, the <strong>Process</strong> button becomes enabled.</li>
        <li>Click <strong>Process</strong> to run PPK. You can leave this page and come back later.</li>
        <li>When finished, <code>result.pos</code> appears and the plot on the right will show the solution.</li>
      </ol>
    </div>

    <div class="mb-3">
      <div class="section-title">Export</div>
      <div class="text-muted">
        Click <strong>Export To</strong> to convert <code>result.pos</code> into CSV, KML, KMZ, GPX, and SHP (zipped).
        Click any file name to download. Use the trash icon to delete.
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Upload limits</div>
      <div class="text-muted">
        The maximum upload size is <strong>100MB</strong> for all users. <strong>Pro</strong> and <strong>Enterprise</strong> users can upload up to <strong>1GB</strong>.
      </div>
    </div>

    <div class="mb-1">
      <div class="section-title">Tips</div>
      <ol class="mb-0 text-muted">
        <li>Double-click a point on the plot to open Google Maps satellite view at that location.</li>
        <li>Files are kept for a limited time (7 days).</li>
      </ol>
    </div>
  </div>
</div>


